export enum EIcMetadataXSource {
  IC_CLIENT = 'IC_CLIENT',
  IC_LEGAL_ENTITY = 'IC_LEGAL_ENTITY',
  IC_ELEMENTARY_CLIENT = 'IC_ELEMENTARY_CLIENT',
}

export enum EJedeaiMetadataXSource {
  SPARK_MONTAGE = 'SPARK_MONTAGE',
  SPARK_MONTAGE_SEARCH = 'SPARK_MONTAGE_SEARCH',
  SPARK_PRODUCT_ISSUE = 'SPARK_PRODUCT_ISSUE',
  SPARK_PRODUCT_ISSUE_SEARCH = 'SPARK_PRODUCT_ISSUE_SEARCH',
  ELIOT_BASKET = 'ELIOT_BASKET',
  ELIOT_BASKET_SEARCH = 'ELIOT_BASKET_SEARCH',
  ELIOT_FLOW = 'ELIOT_FLOW',
  ELIOT_FLOW_SEARCH = 'ELIOT_FLOW_SEARCH',
  X_ONE_DEAL = 'X_ONE_DEAL',
  X_ONE_DEAL_SEARCH = 'X_ONE_DEAL_SEARCH',
  GALAXY_PRODUCT = 'GALAXY_PRODUCT',
  GALAXY_PRODUCT_SEARCH = 'GALAXY_PRODUCT_SEARCH',
  MAESTRO_COUNTERPARTY = 'MAESTRO_COUNTERPARTY',
  MAESTRO_COUNTERPARTY_SEARCH = 'MAESTRO_COUNTERPARTY_SEARCH',
  MAESTRO_CARE_COUNTERPARTY = 'MAESTRO_CARE_COUNTERPARTY',
  MAESTRO_CARE_COUNTERPARTY_SEARCH = 'MAESTRO_CARE_COUNTERPARTY_SEARCH',
  MAESTRO_LEGAL_ENTITY = 'MAESTRO_LEGAL_ENTITY',
  MAESTRO_LEGAL_ENTITY_SEARCH = 'MAESTRO_LEGAL_ENTITY_SEARCH',
  TERMSHEET_CONTROL = 'TERMSHEET_CONTROL',
  TERMSHEET_CONTROL_SEARCH = 'TERMSHEET_CONTROL_SEARCH',
}

export type IcMetadataXSource = keyof typeof EIcMetadataXSource;
export type JedeaiMetadataXSource = keyof typeof EJedeaiMetadataXSource;

export const IC_METADATA_X_SOURCE_LIST = Object.keys(EIcMetadataXSource);
export const JEDEAI_METADATA_X_SOURCE_LIST = Object.keys(EJedeaiMetadataXSource);
